import * as _ from "lodash";
import * as React from "react";
import { Popup, Icon, Label } from "semantic-ui-react";
import {
  Event,
  IBaseProps,
  IBaseState,
  Base,
  IResource,
} from "src/components/Common/Base";
import InviteMemberModel from "../Common/InviteMemberModal";
import { UsersStatus } from "../Session/withAuthorization";

export interface IListUsersProps extends IBaseProps {
  authUser: any;
  orgId: string;
  resource: IResource;
  usersStatus: UsersStatus;
}

export interface IListUsersState extends IBaseState {
  members: any[];
  openShareModal: boolean;
  resourceType: string;
}
export default class ListUsers extends Base<IListUsersProps, IListUsersState> {
  private static INITAL_STATE = {
    ...Base.BASE_INITAL_STATE,
    members: [],
    openShareModal: false,
    resourceType: "",
  };

  constructor(props: IListUsersProps) {
    super(props);
    this.state = {
      ...ListUsers.INITAL_STATE,
      resourceType: this.getResourceType(props.resource.api),
    };
  }

  public render() {
    const { members, openShareModal, resourceType } = this.state;

    return (
      <React.Fragment>
        {members &&
          members.slice(0, 3).map((member, index) => {
            return (
              <React.Fragment key={`${member.id}_${index}`}>
                {Base.getAvatar(member, this.props.usersStatus[member.uid])}
                {members.length > 3 && <Label circular={true}>...</Label>}
              </React.Fragment>
            );
          })}
        <Popup
          position="bottom left"
          content={`Invite users to ${this.props.resource.name} ${resourceType}`}
          trigger={
            <Icon
              link={true}
              circular={false}
              name="user plus"
              color="purple"
              onClick={() => this.handleShareIconClick()}
            />
          }
        />
        {openShareModal && (
          <InviteMemberModel
            {...this.props}
            open={openShareModal}
            setModal={this.setOpenShareModal}
            userAdded={this.handleUserAdded}
          />
        )}
      </React.Fragment>
    );
  }

  public componentDidMount = () => {
    this.getData();
  };

  private getResourceType = (api) => {
    switch (api.constructor.name) {
      case "Analyses":
        return "Analysis";
      case "Datasource":
        return "Datasource";
      case "Dashboards":
        return "Dashboard";
      default:
        return "";
    }
  };

  private handleUserAdded = () => {
    this.getData();
  };

  protected getData = () => {
    const { orgId, authUser, resource } = this.props;
    const { api, id } = resource;
    api
      .requestListMembers(orgId, authUser.uid, id)
      .then((requestRef: firebase.database.Reference) => {
        this.getListner(
          api.getApiResponse(orgId, authUser.uid, requestRef.key),
          Event.Value,
          (snapshot: firebase.database.DataSnapshot) => {
            const resp = snapshot.val();
            if (resp) {
              const members = _.filter(
                resp.members,
                (m) => m.uid !== authUser.uid
              );
              this.setState({ members });
            }
          }
        );
      });
  };

  private handleShareIconClick = () => {
    this.setState({
      openShareModal: true,
    });
  };

  private setOpenShareModal = (open: boolean) => {
    this.setState({ openShareModal: open });
  };
}



// WEBPACK FOOTER //
// ./src/components/Query/ListUsers.tsx